import "./SignupPage.css";
import SignupForm from "../../commen/form/signup/SignupForm";
const SignupPage = () => {
  return (
    <div>
      <SignupForm />
    </div>
  );
};

export default SignupPage;
